import { types } from 'mobx-state-tree';

export const configCatFlag = types
  .model({
    blueBanner: types.maybeNull(
      types.model({
        display: types.maybeNull(types.boolean),
        message: types.maybeNull(types.string),
      }),
    ),
    redBanner: types.maybeNull(
      types.model({
        display: types.maybeNull(types.boolean),
        message: types.maybeNull(types.string),
      }),
    ),
  })
  .views(self => ({
    get getBlueBannerDisplay() {
      if (self.blueBanner?.display === true) return true;
      else return false;
    },
    get getRedBannerDisplay() {
      if (self.redBanner?.display === true) return true;
      else return false;
    },
  }))
  .actions(self => ({
    setBlueBanner: (message: string, display: boolean) => {
      self.blueBanner = {
        message,
        display,
      };
    },
    setRedBanner: (message: string, display: boolean) => {
      self.redBanner = {
        message,
        display,
      };
    },
  }));

export default configCatFlag;
